/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Bootstrap Angular FIRST, then initialize Sentry to reduce critical path latency
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    // Only production builds report. The dev stores and localhost build with the
    // development configuration (environment.production false) and were filling
    // the production quota with their own errors.
    if (!environment.production) return;
    // Defer Sentry init until browser is idle to reduce TBT
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(() => initSentry(), { timeout: 5000 });
    } else {
      // Fallback for Safari
      setTimeout(() => initSentry(), 2000);
    }
  })
  .catch((err) => console.error(err));

function initSentry() {
  Sentry.init({
    dsn: "https://a9de1702052f921d6bd959b2c5da4086@o4508162247557120.ingest.us.sentry.io/4508778707484672",
    integrations: [
      Sentry.browserTracingIntegration(),
      // Replay integration loaded lazily below
    ],
    // A tab still on the previous build asks for lazy chunks the deploy removed.
    // ChunkReloadErrorHandler reloads it onto the new build, so these are not
    // actionable, and right after a deploy they arrive in bursts large enough to
    // exhaust the Sentry quota (429s). Drop them at the source.
    ignoreErrors: [
      'Failed to fetch dynamically imported module',
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Failed to load module script',
      /Loading (CSS )?chunk/,
      'ChunkLoadError',
      'NG0750',
    ],
    // Tracing off: transactions were burning the shared quota (DEV-11772).
    tracesSampleRate: 0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/producebox\.navego\.tech/,
      /^https:\/\/theproducebox\.com/,
    ],
    // Session Replay: record only the sessions that hit an error.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });

  // Lazy load replay integration after another idle period
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(() => {
      Sentry.addIntegration(Sentry.replayIntegration());
    }, { timeout: 10000 });
  } else {
    setTimeout(() => {
      Sentry.addIntegration(Sentry.replayIntegration());
    }, 5000);
  }
}
